<template>
  <van-popup v-model="showSelect" position="bottom" get-container="body" @closed="onClosed">
    <div class="headTitle">选择常用联系人</div>
    <div class="backRect">
      <div v-for="(item,index) in list" :key="item.customerLogId" class="lineRect" :style="selectIndex===index?'border-color:'+GetColorMainBack()+';':'border-color:#fff;' ">
        <div class="icon" @click="onSelect(index)">
          <img :src="item.headIcon?item.headIcon:'/img/defaultHead.jpg'">
        </div>
        <div class="datas" @click="onSelect(index)">
          <div class="localname">{{ item.loaclName }}</div>
          <div class="name">{{ item.lastName }} {{ item.firstName }}</div>
          <div class="info">证件号码:{{ item.idCardNumber?item.idCardNumber:item.passportNumber }}</div>
        </div>
      </div>
    </div>

    <div class="downButton">
      <van-button type="primary" size="large" :disabled="selectIndex===undefined" :color="GetColorMain()" @click="onSelectCustomer">选择</van-button>
    </div>
  </van-popup>

</template>
<script>
import { Popup, Button } from 'vant'
import request from '@/utils/request'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'

export default {
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button
  },
  props: {
    // eslint-disable-next-line
    value: Boolean,
  },
  data() {
    return {
      showSelect: false,
      list: [],
      selectIndex: undefined
    }
  },
  watch: {
    value(newValue) {
      this.selectIndex = undefined
      if (newValue) {
        this.showSelect = true
        this.onInit(() => {

        })
      }
    }
  },
  created() {
    this.list = this.typelist
  },
  methods: {
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetColorMainLine,
    onClosed() {
      this.$emit('input', false)
    },
    onInit(callback) {
      request({
        url: '/storeHelper/getUserCustomerInfoList',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.list = response.data
        if (callback) {
          callback()
        }
      })
    },
    onSelect(index) {
      this.selectIndex = index
    },
    onSelectCustomer() {
      this.$emit('change', this.list[this.selectIndex])
      this.showSelect = false
    }
  }
}
</script>

<style scoped>
.backRect{
    min-height: 30vh;
    max-height: 40vh;
    padding: 1em;
    overflow-y: scroll;
}
.lineRect{
    background-color: #fff;
    position: relative;
    height: 4em;
    margin-bottom: 1em;
    border: 1px solid #fff;
}
.lineRect .icon{
    position: absolute;
    height: 4em;
    width: 3.0786em;
}
.lineRect .icon img{
    height: 100%;
    width: 100%;
}
.lineRect .datas{
    position: absolute;
    left: 4em;
    top: 0em;
    bottom: 0.5em;
    right: 0.5em;
}
.lineRect .datas .name{
    color: #999;
    font-size: 0.8em;
    margin: 0.3em 0;
}
.lineRect .datas .info{
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 0.9em;
}
.headTitle{
    text-align: center;
    font-size: 0.9em;
    font-weight: 700;
    padding: 1em 0;
}
</style>
